(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["button~dropdown~index~input~table"],{

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/mixins/sizeable/index.js
var sizeable = __webpack_require__(98);

// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__(6);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/button/button.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  全局mixins,from `src/mixins`



var button_prefixCls = 'meg-button';
/* harmony default export */ var button_button = ({
  name: 'MegButton',
  props: {
    loading: utils["d" /* vueTypes */].bool.def(false),
    size: utils["d" /* vueTypes */].oneOf(['small', 'large', 'middle']).def('middle'),
    type: utils["d" /* vueTypes */].oneOf(['default', 'primary', 'secondary', 'danger', 'text']).def('default'),
    icon: utils["d" /* vueTypes */].any,
    disabled: utils["d" /* vueTypes */].bool.def(false),
    classProps: utils["d" /* vueTypes */].string,
    styles: utils["d" /* vueTypes */].object
  },
  data: function data() {
    return {
      isClick: false,
      timer: null
    };
  },
  mixins: [sizeable["a" /* default */]],
  computed: {
    classes: function classes() {
      var _ref;

      var size = this.size,
          sizeableClasses = this.sizeableClasses,
          type = this.type,
          classProps = this.classProps,
          icon = this.icon;
      return _ref = {}, _defineProperty(_ref, button_prefixCls, true), _defineProperty(_ref, "".concat(button_prefixCls, "-").concat(type), type === 'default' || type === 'primary' || type === 'secondary' || type === 'danger' || type === 'text'), _defineProperty(_ref, sizeableClasses, !!(size === 'large' || size === 'small')), _defineProperty(_ref, classProps, classProps), _defineProperty(_ref, "".concat(button_prefixCls, "-has-icon"), icon), _ref;
    }
  },
  methods: {
    click: function click() {
      if (this.disabled) return;
      this.$emit('click');
    },
    mouseOver: function mouseOver() {
      this.$emit('mouseover');
    },
    changeClickStatus: function changeClickStatus(isClick) {
      var _this = this;

      this.isClick = isClick;
      this.timer = setTimeout(function () {
        _this.isClick = false;
      }, 300);
    }
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
    clearTimeout(this.colorTimer);
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        click = this.click,
        mouseOver = this.mouseOver,
        disabled = this.disabled,
        loading = this.loading,
        icon = this.icon,
        styles = this.styles,
        $slots = this.$slots,
        isClick = this.isClick,
        changeClickStatus = this.changeClickStatus;
    var loadingIconNode = loading && h("meg-icon", {
      attrs: {
        height: "16px",
        name: "megui-loading"
      },
      "class": "".concat(button_prefixCls, "-loading")
    });
    var iconNode = icon && h("meg-icon", {
      attrs: {
        height: "16px",
        name: icon
      }
    });
    var children = $slots.default && h("span", {
      "class": "".concat(button_prefixCls, "-words")
    }, [$slots.default]);
    return h("button", {
      "class": external_classnames_default()(classes),
      style: styles,
      attrs: {
        disabled: disabled || loading,
        "megbutton-click-animating": isClick
      },
      on: {
        "click": click,
        "mouseover": mouseOver,
        "mousedown": changeClickStatus.bind(this, true)
      }
    }, [loadingIconNode || iconNode, children]);
  }
});
// CONCATENATED MODULE: ./src/components/button/group.jsx
function group_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ var group = ({
  name: 'MegButtonGroup',
  props: {},
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots;
    var prefixCls = 'meg-button-group';

    var classes = group_defineProperty({}, prefixCls, true);

    return h("div", {
      "class": external_classnames_default()(classes)
    }, [$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/components/button/index.jsx

 // 组件的样式文件
// import './style/index.scss';
// import './style/dark.scss';

button_button.install = function (Vue) {
  Vue.component(button_button.name, button_button);
  Vue.component(group.name, group);
};

/* harmony default export */ var components_button = __webpack_exports__["default"] = (button_button);

/***/ })

}]);